import { lazy } from 'react';
import { ComponentsMapInterface } from './types';

export enum ComponentsMapEnums {
  HOME,
}

export const ComponentsMap: ComponentsMapInterface = {
  HOME: lazy(() => import('../pages/home')),
};
